module.exports = __webpack_public_path__ + "img/instagram.7d369fb7.png";